import React from "react";
import EventDetailSkeleton from "./skeleton/EventDetailSkeleton";
import ScrollContent from "components/UI/ScrollContent";
import styles from "./EventDetail.module.css";
import dateStart from "assets/images/date-start.svg";
import dateEnd from "assets/images/date-end.svg";
import placeholder1000x625 from "assets/placeholder/1000x625.png";

const EventDetail = ({ details, loading }) => {
  if (loading || !details) {
    return <EventDetailSkeleton />;
  }

  return (
    <div className={styles.Detail} style={{ height: "100%" }}>
      <h2 className={styles.Shop}> {details.destination_name}</h2>
      <div className={styles.DetailBox} >
        <ScrollContent mr={32}>
          <h2 className={styles.Title}> {details.title}</h2>
          <img
            src={details.thumb || placeholder1000x625}
            alt="shop-logo"
            className={styles.Thumbnail}
          />
          <div className={styles.DateRow}>
            <div className={styles.DateItem}>
              <img src={dateStart} alt="icon" />
              <span>{details.start_date}</span>
            </div>
            <div className={styles.DateItem}>
              <img src={dateEnd} alt="icon" />
              <span>{details.end_date}</span>
            </div>
          </div>
          <div
            className={styles.Content}
            dangerouslySetInnerHTML={{ __html: details.content }}
          ></div>
        </ScrollContent>
      </div>
    </div>
  );
};

export default EventDetail;
